import React from "react";
import Spin from "antd/es/spin";
import { Props } from "./types";
import { colors } from "assets/styles/colors";

const Loader: React.FC<Props> = (props: Props) => {
  const { fullscreen, size = 'default' } = props;

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color:colors.secondary }}>
      <Spin fullscreen={fullscreen} size={size}/>
    </div>
  );
};

export default Loader;
